export default function Section16() {
    const processSteps = [
        {
            title: "1. Discovery and Goal Setting",
            description:
                "We start by learning about your business, target audience, and goals. Whether your goal is to increase online sales, demo requests, or newsletter signups, we define clear KPIs to measure success.",
        },
        {
            title: "2. CRO Audit and User Behavior Analysis",
            description:
                "Using analytics tools like heatmaps, scroll maps, and session recordings, we identify where users lose interest or drop off. We analyze click behavior, conversion funnels, and traffic sources to find key areas of improvement.",
        },
        {
            title: "3. Strategy and Hypothesis",
            description:
                "Based on data, we create a strategy outlining what needs to change and why. This may include simplifying navigation, optimizing checkout steps, improving form designs, or rewriting call-to-action text.",
        },
        {
            title: "4. A/B Testing and Implementation",
            description:
                "We make controlled changes and test them against your current version to see what drives more conversions. Every adjustment, from button colors to layout structure is validated by real user data.",
        },
        {
            title: "5. Implementation and Reporting",
            description:
                "After identifying winning variations, we apply them across your website and share transparent reports showing measurable improvements in conversions, engagement, and ROI.",
        },
        {
            title: "6. Continuous Optimization",
            description:
                "CRO is not a one-time process. User behavior and market trends change constantly, so we continue testing, refining, and improving to maintain long-term growth.",
        },
    ];

    return (
        <div className="Section16 py-[30px] md:py-[30px] bg-white">
            {/* Section Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Our Data-Driven <span className="text-[#DA2128]">CRO Process</span>
                </h2>
                <p className="mt-6 text-[#555] text-[16px] md:text-[18px] max-w-[700px] mx-auto">
                    At Mean3, our approach is transparent, measurable, and customized for every business.
                </p>
            </div>

            {/* Process Steps Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 w-[90%] md:w-[85%] mx-auto">
                {processSteps.map((step, index) => (
                    <div
                        key={index}
                        className={`p-6 rounded-2xl shadow-md text-left transition ${index % 2 === 0
                            ? "bg-[#E42E35] text-white"
                            : "bg-white text-[#151515] border border-gray-200"
                            }`}
                    >
                        <h3 className="text-[18px] md:text-[20px] font-bold mb-3">
                            {step.title}
                        </h3>
                        <p className="text-[14px] md:text-[15px] leading-[22px]">
                            {step.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
